var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 5.75,
    fill: "#FFFAF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 5.75,
    stroke: "var(--primary-color-text)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8967 18.75C17.4966 18.75 18.7935 17.4628 18.7935 15.875C18.7935 14.2872 17.4966 13 15.8967 13C14.2969 13 13 14.2872 13 15.875C13 17.4628 14.2969 18.75 15.8967 18.75Z",
    fill: "var(--primary-color-text)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6818 15.6619C25.83 13.4752 24.3513 11.5841 22.4285 10.2224C20.5057 8.86074 18.2229 8.0881 15.8625 8C13.502 8.0881 11.2193 8.86074 9.29643 10.2224C7.37358 11.5841 5.8949 13.4752 5.04314 15.6619C4.98562 15.8198 4.98562 15.9927 5.04314 16.1506C5.8949 18.3373 7.37358 20.2284 9.29643 21.5901C11.2193 22.9518 13.502 23.7244 15.8625 23.8125C18.2229 23.7244 20.5057 22.9518 22.4285 21.5901C24.3513 20.2284 25.83 18.3373 26.6818 16.1506C26.7393 15.9927 26.7393 15.8198 26.6818 15.6619ZM15.8625 20.5781C14.9315 20.5781 14.0214 20.3041 13.2473 19.7908C12.4732 19.2774 11.8699 18.5478 11.5136 17.6941C11.1573 16.8404 11.0641 15.9011 11.2457 14.9948C11.4273 14.0886 11.8757 13.2561 12.534 12.6027C13.1923 11.9494 14.031 11.5044 14.9441 11.3241C15.8572 11.1439 16.8037 11.2364 17.6638 11.59C18.524 11.9436 19.2591 12.5424 19.7764 13.3107C20.2936 14.079 20.5697 14.9822 20.5697 15.9062C20.5677 17.1447 20.0712 18.3319 19.1888 19.2077C18.3065 20.0834 17.1103 20.5762 15.8625 20.5781Z",
    fill: "var(--primary-color-text)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewUploadFile);
export default __webpack_public_path__ + "static/media/viewUploadFile.d9e2275d899f4d1b8778d05ebf04832e.svg";
export { ForwardRef as ReactComponent };